import RRPTable from './RRPTable';

export default RRPTable;
